module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_plan_show_bg_01-d0036cf8f3467f14952a82c1dbe12877.jpg";